import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * GtagPageViewTracker.tsx
 * ----------------------------------------
 * - gtagSendPageView: 페이지뷰 전송 함수
 * - GtagPageViewTracker: 라우트 변경 시마다 page_view를 GA4로 전송하는 컴포넌트
 * ----------------------------------------
 */

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

/**
 * gtagSendPageView
 * ----------------------------------------
 * 페이지뷰 전송
 * @param path  - 전송할 경로
 * @param title - 페이지 타이틀 (기본값: document.title)
 */
function gtagSendPageView(title?: string): void {
    const url = new URL(window.location.href);
    const mapId = url.searchParams.get("id");
    const pagePath = window.location.pathname + window.location.search;

    const params: Record<string, any> = {
        page_title: title ?? document.title,
        page_location: window.location.href,
        page_path: pagePath,
    };

    // ~/map?id= 형태면 map_id 파라메터 추가함 -> 애널리틱스에서 필터주기위함
    if (url.pathname === "/map" && mapId) {
        params.map_id = mapId;
    }

    window.gtag?.("event", "page_view", params);
}

/**
 * GtagPageViewTracker 컴포넌트
 * ----------------------------------------
 * - react-router-dom의 useLocation 훅 사용
 * - BrowserRouter 바로 안쪽에 배치
 * - 라우트 변경 시마다 gtagSendPageView 호출
 */
export default function GtagPageViewTracker() {
    const location = useLocation();

    useEffect(() => {
        // document.title 은 서블릿에서 내려준 값 사용
        gtagSendPageView(document.title);
    }, [location.key]);

    return null;
}
